<style lang="less">
 @import './header.less';
</style>
<template>
	<div class="m_header_content">
		<div class="el-icon-s-fold m_header_menu_tool" v-if="fold" @click="changeFold"></div>
		<div class="el-icon-s-unfold m_header_menu_tool" v-else @click="changeFold"></div>
		<div class="m_header_mine">
			<el-popover placement="bottom" trigger="click" width="90">
				<div class="m_user_tools">
					<div class="m_user_tools_item" @click="showPwd">{{$t('login.reviseword')}}</div>
					<div class="m_user_tools_item" @click="logout">{{$t('login.loginout')}}</div>
				</div>
				<span slot="reference">
					{{ userInfo.accountFullName }}
					<span class="el-icon-caret-bottom"></span>
				</span>
			</el-popover>
		</div>
		<el-dialog :close-on-click-modal="false" :title="$t('login.reviseword')" :visible.sync="dialogVisible" :modal="false" :show-close="false" v-el-drag-dialog >
			<div>
				<el-form ref="form" :model="user" label-width="auto" :rules="rules">
					<el-form-item :label="$t('login.oldword')" prop="originalPassword">
						<el-input v-model="user.originalPassword" :placeholder="$t('login.oldholder')"></el-input>
					</el-form-item>
					<el-form-item :label="$t('login.newword')" prop="newPassword">
						<el-input v-model="user.newPassword" :placeholder="$t('login.newholder')"></el-input>
					</el-form-item>
					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="save" size="mini">{{$t('global.save')}}</el-button>
				<el-button @click="dialogVisible = false" size="mini" >{{$t('global.cancel')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import storage from '@/utils/storage';
	export default{
		name: "MHeader",
		data(){
			return{
				fold:true,
				dialogVisible:false,
				user:{
					originalPassword:null,
					newPassword:null,
				},
				rules:{
					originalPassword: [{
							required: true,
							message: this.$t('login.oldwordMsg'),
							trigger: "blur"
					}],
					newPassword:[{
						required: true,
						message: this.$t('login.newwordMsg'),
						trigger: "blur"
					}]
				},
			}
		},
		computed: {
			userInfo() {
		        return this.$store.state.member.userInfo;
		 	}
		},
		mounted(){
			console.log(this.userInfo)
		},
		methods:{
			changeFold(ind){
				this.fold = !this.fold;
				this.$emit('changeFold',!this.fold)
			},
			showPwd(){
				this.dialogVisible=true;
			},
			save(){
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.$http.log.editPassword(this.user).then((res) => {
							if(res.return_code==0) {
								this.dialogVisible=false;
							  	this.$message({
									message: this.$t('login.loginoutMsg'),
									type: 'success',
									duration:1500,
									onClose:()=>{
		        						this.$store.dispatch('member.outLogin');
		        						window.location.href='/#/login';
									}
								});
							}
							else {
							  	this.$message({
									message: this.$t(res.return_key),
									type: 'error',
									duration:3000
								});
							}
						}, (err) => {
							  	this.$message({
									message: err,
									type: 'error',
									duration:3000
								});
							});
					} else {
						return false;
					}
				});
			},
			logout(){
				 this.$confirm(this.$t('login.loginoutTitle2'),this.$t('login.loginoutTitle'),{
		          	confirmButtonText: this.$t('global.define'),
		          	cancelButtonText: this.$t('global.cancel'),
		          	type: 'error'
		    	 }).then(() => {
		        	this.$http.log.logout().then((res) => {
						if(res.return_code==0) {
						  	this.$message({
								message: this.$t('login.loginoutOk'),
								type: 'success',
								duration:1500,
								onClose:()=>{
	        						this.$store.dispatch('member.outLogin');
	        						window.location.href='/#/login';
								}
							});
							
						}
						else {
						  	this.$message({
								message: this.$t(res.return_key),
								type: 'error',
								duration:3000
							});
						}
					}, (err) => {
						  this.$message({
							message: err,
							type: 'error',
							duration:3000
						});
					});
		        }).catch(() => {        
		       });
			}
		}
		
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Header/index.vue